import React from 'react';
import { History } from 'app/services/history';
import { withHistory } from 'app/components/router/History';
import Link from 'app/components/router/Link';
import { T } from 'app/components/localization';
import find from 'lodash/find';
import { stringify } from 'query-string';
import { getRedirectTo } from 'app/models/route/selectors';
import { CallbackRef } from 'app/utils/react';

type RedirectCondition = (redirectTo: string) => boolean;

interface IDepProps {
  history: History;
}

export interface IRedirectLinkProps {
  className?: string;
  getRef?: CallbackRef;
  to: string;
  noRedirectConditions?: RedirectCondition[];
  onClick?: (e: React.MouseEvent) => void;
  replace?: boolean;
}

type IProps = IRedirectLinkProps & IDepProps;

const RedirectLink: React.FunctionComponent<IProps> = ({
  history,
  className,
  getRef,
  to,
  noRedirectConditions,
  onClick,
  replace = false,
  children,
}) => {
  let redirectTo = getRedirectTo(history);

  if (noRedirectConditions && find(noRedirectConditions, (cond) => cond(redirectTo))) {
    redirectTo = undefined;
  }

  const href = history.createHref({
    pathname: to,
    search: stringify({ redirectTo }),
  });

  return (
    <T>{t =>
      <Link className={className} getRef={getRef} to={href} onClick={onClick} replace={replace}>
        {children || t('header.login-link')}
      </Link>
    }</T>
  );
};

export default withHistory(RedirectLink);
